import {alpha, Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';
import Table from '@mui/material/Table';
import AppTableContainer from 'main/core/AppTableContainer';
import PropTypes from 'prop-types';
import DocInvTableBody from './DocInvTableBody';
import DocInvTableHeading from './DocInvTableHeader';

const StyledTable = styled(Table)(({theme}) => ({
  '& .MuiTableCell-root': {
    padding: 8,
    fontSize: 11,
    fontWeight: 600,
    borderBottom: `1px solid ${theme.palette.divider}`,
    verticalAlign: 'middle',
  },

  '& .MuiTableCell-head': {
    fontSize: 12,
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '1px',
    color: theme.palette.text.secondary,
    backgroundColor: alpha(theme.palette.secondary.main, 0.02),
    borderBottom: `2px solid ${theme.palette.divider}`,
  },

  '& .MuiTableCell-footer': {
    fontWeight: 700,
    fontSize: 12,
    color: 'text.secondary',
  },

  '& .docGrandTotal': {
    fontWeight: 700,
    letterSpacing: '1px',
    textTransform: 'uppercase',
    color: theme.palette.text.secondary,
    backgroundColor: alpha(theme.palette.secondary.main, 0.02),
    borderTop: `2px solid ${theme.palette.divider}`,
  },
}));

const DocInvTable = ({bodySpec, dataSet}) => {
  return (
    <Box sx={{mb: 8}}>
      <Typography
        sx={{
          mb: 2,
          fontSize: 13,
          fontWeight: 800,
          color: 'text.primary',
          textTransform: 'uppercase',
          letterSpacing: '0.02rem',
          verticalAlign: 'middle',
          textAlign: 'center',
        }}
      >
        {bodySpec.title}
      </Typography>

      <AppTableContainer>
        <StyledTable>
          <DocInvTableHeading fields={bodySpec.fields} />

          <DocInvTableBody
            idfieldname={bodySpec.idfieldname}
            fields={bodySpec.fields}
            dataSet={dataSet}
          />
        </StyledTable>
      </AppTableContainer>
    </Box>
  );
};

DocInvTable.propTypes = {
  bodySpec: PropTypes.shape({
    idfieldname: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(PropTypes.object).isRequired,
    title: PropTypes.string,
  }).isRequired,
  dataSet: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default DocInvTable;
